module.exports = __webpack_public_path__ + "img/hkstp-20210105.8f650b09.jpg";